import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';

const UserDashboard = () => {
  const { user } = useContext(AuthContext);

  return (
    <div>
      <Navbar userRole="user" />
      <div className="container">
        <div style={{ marginBottom: '20px' }}>
          <h1>Panel de Usuario</h1>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default UserDashboard;
